export default {
  approvalResponses: [],
  approvalResponse: undefined,
};
